import ErrMessage from "../components/core/ErrMessage.tsx";
import ChatBubble from "../components/chat/core/ChatBubble.tsx";
import { ROUTE_CHAT, ROUTE_PRODUCT } from "../const/routes";
import { IconAlertSquareRounded, IconX } from "@tabler/icons-react";
import FetchChat from "../components/messages/fetch/FetchChat";
import { Link, useNavigate, useParams } from "react-router-dom";
import ItemTitle from "../components/item/core/ItemTitle";
import ItemOwner from "../components/item/core/ItemOwner";
import ItemImage from "../components/item/core/ItemImage";
import ScrollToBottom from "../components/chat/core/ScrollToBottom";
import ReactiveToggle from "../components/core/ReactiveToggle";
import ChatValid from "../components/chat/core/ChatValid";
import MessageForm, {
  MessageFormType,
} from "../components/messages/form/MessageForm";
import { SubmitContext } from "../context/context.submit";
import { useContext, useEffect } from "react";
import { SubmitHandler } from "react-hook-form";
import { MessagePostType } from "../types/Message";
import { sendMessage } from "../fetch/fetch.message";
import { CHAT_UNREAD_URL, CHAT_URL, MESSAGE_URL } from "../fetch/const.routes";
import { ChatType } from "../types/Chat.ts";
import { LOADING_CIRCLE } from "../components/core/loading/LoadingCircle.tsx";
import SEO from "../components/core/SEO.tsx";
import { useSWRConfig } from "swr";

function OpenChat() {
  const { mutate } = useSWRConfig();
  const { chatId } = useParams();
  const { setError } = useContext(SubmitContext);
  const navigate = useNavigate();
  useEffect(() => {
    mutate(`${CHAT_URL}${chatId}`);
    mutate(`${CHAT_UNREAD_URL}`);
  }, []);
  if (!chatId) return <ErrMessage message={"Chat is not here."} />;

  const handleSubmit: SubmitHandler<MessageFormType> = async (data) => {
    const message: MessagePostType = {
      content: data.chatMessage,
      chatId: chatId,
    };
    const res = await sendMessage(chatId, message);
    if (!res.ok) {
      setError(res.error);
      return;
    }
    await mutate(MESSAGE_URL + chatId);
  };
  return (
    <div className="h-dvh w-full z-50 overscroll-none touch-none bg-base-100">
      <SEO title="Chat" url={ROUTE_CHAT(chatId)} noIndex />
      <div className="flex flex-col justify-end h-full items-center gap-2 z-50 overscroll-none touch-none p-page safe-bottom safe-top-with-hanger">
        <nav className="sticky flex w-full justify-around gap-8 items-center p-2 top-0 glass-blurry rounded-box z-51 touch-none 2xl:w-1/2">
          <ReactiveToggle transitional={() => navigate(ROUTE_CHAT())}>
            {(handleClick, isPending) => (
              <button
                className={`btn btn-circle btn-ghost active:btn-error ${isPending && "btn-error"}`}
                onClick={handleClick}
              >
                <IconX />
              </button>
            )}
          </ReactiveToggle>

          <FetchChat id={chatId} fallback={LOADING_CIRCLE}>
            {(chat: ChatType) => (
              <Link
                className="flex justify-between gap-5 bg-base-300 items-center px-3 h-16 rounded-box grow overflow-hidden"
                to={ROUTE_PRODUCT(chat.productId)}
              >
                <div className="flex flex-col w-full">
                  <ItemTitle id={chat.productId} />
                  <div className="text-xs uppercase font-semibold opacity-60">
                    <ItemOwner id={chat.productId} />
                  </div>
                </div>
                <ItemImage
                  className="size-18 rounded-full"
                  id={chat.productId}
                />
              </Link>
            )}
          </FetchChat>
        </nav>
        <section className="flex flex-col w-full 2xl:w-1/2 overflow-y-scroll grow z-51 bg-base-100 touch-nonezx ">
          <div className="grow" />
          <ScrollToBottom>
            <ChatBubble chatId={chatId} />
          </ScrollToBottom>
          <div className="z-51">
            <ChatValid
              chatId={chatId}
              loading={<MessageForm onSubmit={() => {}} />}
              fallback={
                <div role="alert" className="alert">
                  <IconAlertSquareRounded />
                  <span>Der Chat ist beendet.</span>
                </div>
              }
            >
              <MessageForm onSubmit={handleSubmit} />
            </ChatValid>
          </div>
        </section>
      </div>
    </div>
  );
}

export default OpenChat;
